import { shoulderHeightElements } from '@flows/configs/petHealthV2/steps/elements/shoulderHeight'
import { copyCustomerZipCode } from '@flows/configs/petHealthV2/utils'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'

const STEP_AFTER_SHOULDER_HEIGHT = { native: 'postal_code', web: 'pet_quote' } as const

const shoulder_height = (params: StepConfigParams, platform: 'native' | 'web') =>
  ({
    ...fragmentStep(
      shoulderHeightElements(params, platform),
      params,
      STEP_AFTER_SHOULDER_HEIGHT[platform]
    ),
    onSubmit: {
      type: 'simpleHook',
      callback: (flowValues: FlowValues) => copyCustomerZipCode(params, flowValues),
    },
  }) as const satisfies AnyStepConfiguration

export default shoulder_height
